import { isDemoEnvironment } from '~/shared/lib/environment'
import { useDemoResetSchedule } from './use-demo-reset-schedule'

const DemoEnvironmentIndicator = () => {
  const countdown = useDemoResetSchedule()

  return isDemoEnvironment ? (
    <div
      className="sticky top-0 z-[1000] flex h-10 items-center justify-center bg-amber-100 px-4 text-center text-sm font-semibold text-amber-950"
      role="status"
    >
      Демо-среда
      {countdown && (
        <span aria-live="off" className="ml-2 font-normal">
          {countdown}
        </span>
      )}
    </div>
  ) : null
}

export default DemoEnvironmentIndicator
